import { S } from "../app/store.js";
import { ACC } from "./reference.js";

function bal(code, asOf = "9999-12-31", from = "0000-01-01") {
  let b = 0;
  for (const j of S.je)
    if (j.status === "POSTED" && j.date <= asOf && j.date >= from)
      for (const l of j.lines) if (l.a === code) b += l.d - l.c;
  return b;
}

function natural(code, asOf, from) {
  const a = ACC[code],
    b = bal(code, asOf, from);
  return a.type === "A" || a.type === "X" ? b : -b;
}

function journalOf(j) {
  const dr = (a) => j.lines.some((l) => l.a === a && l.d),
    cr = (a) => j.lines.some((l) => l.a === a && l.c);
  return cr("2240") && dr("1110")
    ? "SALES"
    : dr("1020")
      ? "CR"
      : cr("1020")
        ? "CD"
        : cr("2110")
          ? "PUR"
          : "GJ";
}

function nextJV() {
  return "JV-" + String(++S.seq.je).padStart(4, "0");
}

export { bal, natural, journalOf, nextJV };
